<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCog } from "@mdi/js";
export default {
  name: "MdiCog",
  data() {
    return {
      svgPath: mdiCog,
    };
  },
};
</script>
